// test72
(72 && 0);
